import { HttpMethod } from '@teqplay/api'

import { requestBuilder } from '../builder'

export type ISODateTimeString = string

export type TFeedbackInput = {
  message: string
  contactEmail: string
}

export type TFeedbackOutput = {
  _id: string
  message: string
  contactEmail: string
  submittedAt: ISODateTimeString
}

const post = requestBuilder.type<TFeedbackInput, TFeedbackOutput>().request(({ input }) => ({
  path: `/v1/feedback`,
  method: HttpMethod.POST,
  init: {
    body: JSON.stringify(input)
  }
}))

const feedback = { post }
export default feedback
